import { useLanguage } from "../i18n/LanguageContext";
import { useEffect } from "react";
import DebuggingOctopus from "../components/DebuggingOctopus";
import { Link } from "react-router-dom";
import TeddyBearSwitch from "../components/TeddyBearSwitch";

const Home = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Set page keywords
    document.querySelector('meta[name="keywords"]').setAttribute(
      "content",
      `full-stack developer, software developer, software engineer, computer engineer, software developer in Kuwait,Kuwait, 
      Coded Academy, AUM, Ruby on Rails, Ruby, React, JavaScript, TypeScript, Nextjs, HTML, CSS, website, application,
      home page`,
    );
  }, []);

  return (
    <div id="home" className="main-div px-5 py-4">
      <div className="header-name">
        <h1 className="pt-5">{t("common.name")}</h1>
        <div className="titles">
          <p>{t("home.engineerTitle")}</p>
          <p>{t("home.developerTitle")}</p>
          <h5 className="mb-0 mt-4">{t("home.introduction")}</h5>
          <small>
            <Link className="here-link" to="/about" key="about">
              {t("home.aboutPrompt")}
            </Link>
          </small>
        </div>

        <h6 className="mt-5 gray-text">
          <span>{t("home.boredPrompt")}</span> <br />
          {t("home.switchHint")}
        </h6>
        <div className="teddy-container mt-3">
          <TeddyBearSwitch />
        </div>
      </div>
      <div className="header-pic">
        <DebuggingOctopus />
      </div>
    </div>
  );
};

export default Home;
